import { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Flex, Spinner } from '@radix-ui/themes';
import cognitoProvider from '../../../cognito';
import useAuthStore from '../../../store/authStore';

function AuthGuard() {
  const setAuthEmail = useAuthStore((s) => s.setAuthEmail);
  const [checking, setChecking] = useState(true);
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    const check = async () => {
      try {
        let session = cognitoProvider.getCurrentSession();

        if (!session?.isValid()) {
          session = await cognitoProvider.refreshCurrentSession();
        }

        if (session?.isValid()) {
          const user = cognitoProvider.getCurrentUser();

          if (user) {
            const attrs = user.getAttributes();
            setAuthEmail((attrs['email'] as string | undefined) ?? user.getUsername());
            setVerified(true);
          }
        }
      } catch {
        setVerified(false);
      } finally {
        setChecking(false);
      }
    };

    check();
  }, [setAuthEmail]);

  if (checking) {
    return (
      <Flex align="center" justify="center" style={{ height: '100vh' }}>
        <Spinner size="3" />
      </Flex>
    );
  }

  if (!verified) {
    return <Navigate to="/sign-in" replace />;
  }

  return <Outlet />;
}

export default AuthGuard;
